var map = {
	"./adyen--alipay+-tip.png": 2535,
	"./adyen--alipay-tip.png": 5070,
	"./adyen--american-express-tip.png": 4745,
	"./adyen--applepay-tip.png": 8490,
	"./adyen--diners-tip.png": 5955,
	"./adyen--discoverpay-tip.png": 9695,
	"./adyen--googlepay-tip.png": 1207,
	"./adyen--jcb-tip.png": 5839,
	"./adyen--konbini-tip.png": 6798,
	"./adyen--mastercard-tip.png": 6920,
	"./adyen--payeasy-atm-tip.png": 2513,
	"./adyen--payeasy-online-banking-tip.png": 5273,
	"./adyen--paypay-tip.png": 600,
	"./adyen--unionpay-tip.png": 361,
	"./adyen--visa-tip.png": 9887,
	"./adyen--webmoney-tip.png": 6998,
	"./adyen--wechatpay-tip.png": 9538,
	"./airwallex--american-express-tip.png": 2495,
	"./airwallex--applepay-tip.png": 7536,
	"./airwallex--card-tip.png": 7368,
	"./airwallex--googlepay-tip.png": 7657,
	"./airwallex--jcb-tip.png": 4365,
	"./airwallex--konbini-tip.png": 8764,
	"./airwallex--mastercard-tip.png": 1030,
	"./airwallex--payeasy-tip.png": 9160,
	"./airwallex--unionpay-tip.png": 3400,
	"./airwallex--visa-tip.png": 7765,
	"./alipay--paypay-tip.png": 323,
	"./gash--bitcash-tip.png": 8062,
	"./gash--net-cash-tip.png": 7147,
	"./gash--netcash-tip.png": 134,
	"./gash--webmoney-tip.png": 3318,
	"./xsolla--paypal-tip.png": 3431,
	"./xsolla--paypay-tip.png": 2626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8580;